import { isIntegerNumberValid } from "@axtesys/react-tools"

import { PRICE_CODES, PRICE_WEIGHT_CODES, WEIGHT_CODES } from "./constants"

// Other than initially specified and realised,
// the application needs to support a broader range of barcode standards.
// Because of that, explicit GTIN-only support and validation are dropped.
//
// Now numeric barcode numbers ranging from 4 to 48 characters are supported
// (e.g. GTIN [UPC, EAN, ITF; GTIN-8,-12,-13,-14],
//       Code 39 [ISO/IEC 16388:2007] and 128 [ISO/IEC 15417:2007], etc.).
//
// Limit explanation:
// - Lower limit: 4 -  In order to prevent accidental input and
//                     to comply with scanner processing tactics as well as
//                     consider the requirements of the customer,
//                     a barcode number must consist of a minimum of 4 digits.
//
// - Upper limit: 48 - Because it would not be very practicable
//                     to allow even larger possible barcode numbers
//                     (from a scanning/hardware standpoint) and
//                     the GS1-128 standard defines a limit of 48 chars,
//                     do apply the same limit too (https://www.gs1.at/gs1-128).
export function isBarcodeNumberValid(barcodeNumber?: string): boolean {
  if (!barcodeNumber) return false

  return (
    barcodeNumber.length >= 4 &&
    barcodeNumber.length <= 48 &&
    isIntegerNumberValid(barcodeNumber)
  )
}

export function isPriceWeightBarcode(barcodeNumber?: string) {
  if (barcodeNumber?.length != 13) return { truth: false }

  const prefix = +barcodeNumber.slice(0, 2)
  const isPriceWeightCode = PRICE_WEIGHT_CODES.includes(prefix)

  return isPriceWeightCode ? { truth: true, prefix } : { truth: false }
}

export function isPriceCode(prefix: number): boolean {
  return PRICE_CODES.includes(prefix)
}

export function isWeightCode(prefix: number): boolean {
  return WEIGHT_CODES.includes(prefix)
}

export function padArticleNumber(number: string): string {
  return number.padStart(5, "0")
}

export function padBarcodePreview(barcodeNumber: string): string {
  return barcodeNumber.padEnd(15, "0")
}
